import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

function list(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("patientarchives/", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function listOwn(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("users/own/patientarchives", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function create(payload = {}) {
  var sett = { headers: authHeader() };
  return axios
    .post("patientarchives/", payload, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function createOwn(payload = {}) {
  var sett = { headers: authHeader() };
  return axios
    .post("users/own/patientarchives", payload, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function update(id, payload = {}) {
  var sett = { headers: authHeader() };
  return axios
    .put(`patientarchives/${id}`, payload, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function remove(id) {
  var sett = { headers: authHeader() };
  return axios
    .delete(`patientarchives/${id}`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function removeOwn(id) {
  var sett = { headers: authHeader() };
  return axios
    .delete(`users/own/patientarchives/${id}`, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

export const patientArchiveService = {
  list,
  listOwn,
  create,
  createOwn,
  update,
  remove,
  removeOwn,
};


